import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';
import { setContext } from 'svelte';

var root = $.from_html(`<div class="relative"><!></div>`);

export default function Select_root($$anchor, $$props) {
	$.push($$props, true);

	let selected = $.prop($$props, 'selected', 31, () => $.proxy({ value: '', label: '' }));
	let isOpen = $.state(false);

	setContext('select', {
		getSelected: () => selected(),
		isOpen: () => $.get(isOpen),

		setOpen: (open) => {
			$.set(isOpen, open, true);
		},

		select: (value, label) => {
			selected({ value, label });
			$.set(isOpen, false);
			$$props.onSelectedChange?.({ value, label });
		}
	});

	var div = root();
	var node = $.child(div);

	$.snippet(node, () => $$props.children ?? $.noop);
	$.reset(div);
	$.append($$anchor, div);
	$.pop();
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6W10sInNvdXJjZXMiOlsic2VsZWN0LXJvb3Quc3ZlbHRlIl0sInNvdXJjZXNDb250ZW50IjpbIjxzY3JpcHQgbGFuZz1cInRzXCI+XG4gIGltcG9ydCB7IHNldENvbnRleHQgfSBmcm9tICdzdmVsdGUnO1xuXG4gIGxldCB7XG4gICAgc2VsZWN0ZWQgPSAkYmluZGFibGUoeyB2YWx1ZTogJycsIGxhYmVsOiAnJyB9KSxcbiAgICBvblNlbGVjdGVkQ2hhbmdlLFxuICAgIGNoaWxkcmVuLFxuICB9OiB7XG4gICAgc2VsZWN0ZWQ/OiB7IHZhbHVlOiBzdHJpbmc7IGxhYmVsOiBzdHJpbmcgfTtcbiAgICBvblNlbGVjdGVkQ2hhbmdlPzogKGl0ZW06IHsgdmFsdWU6IHN0cmluZzsgbGFiZWw6IHN0cmluZyB9IHwgbnVsbCkgPT4gdm9pZDtcbiAgICBjaGlsZHJlbj86IGFueTtcbiAgfSA9ICRwcm9wcygpO1xuXG4gIGxldCBpc09wZW4gPSAkc3RhdGUoZmFsc2UpO1xuXG4gIHNldENvbnRleHQoJ3NlbGVjdCcsIHtcbiAgICBnZXRTZWxlY3RlZDogKCkgPT4gc2VsZWN0ZWQsXG4gICAgaXNPcGVuOiAoKSA9PiBpc09wZW4sXG4gICAgc2V0T3BlbjogKG9wZW46IGJvb2xlYW4pID0+IHtcbiAgICAgIGlzT3BlbiA9IG9wZW47XG4gICAgfSxcbiAgICBzZWxlY3Q6ICh2YWx1ZTogc3RyaW5nLCBsYWJlbDogc3RyaW5nKSA9PiB7XG4gICAgICBzZWxlY3RlZCA9IHsgdmFsdWUsIGxhYmVsIH07XG4gICAgICBpc09wZW4gPSBmYWxzZTtcbiAgICAgIG9uU2VsZWN0ZWRDaGFuZ2U/Lih7IHZhbHVlLCBsYWJlbCB9KTtcbiAgICB9LFxuICB9KTtcbjwvc2NyaXB0PlxuXG48ZGl2IGNsYXNzPVwicmVsYXRpdmVcIj5cbiAge0ByZW5kZXIgY2hpbGRyZW4/LigpfVxuPC9kaXY+XG4iXSwibWFwcGluZ3MiOiI7O1NBQ1csVUFBVSxRQUFRLFFBQVE7Ozs7dURBRHJDLENBQUM7OztLQUlHLFFBQVEsbURBQWUsS0FBSyxFQUFFLEVBQUUsRUFBRSxLQUFLLEVBQUUsRUFBRTtLQVN6QyxNQUFNLFdBQVUsS0FBSzs7Q0FFekIsVUFBVSxDQUFDLFFBQVE7RUFDakIsV0FBVyxRQUFRLFFBQVE7RUFDM0IsTUFBTSxjQUFRLE1BQU07O0VBQ3BCLE9BQU8sR0FBRyxJQUFhLEtBQUssQ0FBQztTQUMzQixNQUFNLEVBQUcsSUFBSTtFQUNmLENBQUM7O0VBQ0QsTUFBTSxHQUFHLEtBQWEsRUFBRSxLQUFhLEtBQUssQ0FBQztHQUN6QyxRQUFRLEdBQUssS0FBSyxFQUFFLEtBQUs7U0FDekIsTUFBTSxFQUFHLEtBQUs7Z0NBQ08sS0FBSyxFQUFFLEtBQUs7RUFDbkMsQ0FBQzs7Ozs7Ozs7OztBQUVOLENBQUMifQ==